import React from "react";
import { useTranslation } from "react-i18next";
import { MenuItem } from "components/bootstrap";
const StreamCategoriesAction = ({ modalRef, entity }) => {
  const { t } = useTranslation("enterprise_illuminate");
  if (!entity.is_editable) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(MenuItem, { onSelect: () => {
    var _a;
    return (_a = modalRef()) == null ? void 0 : _a.toggle();
  } }, t("stream_categories_action.manage_categories"));
};
export default StreamCategoriesAction;
